<template>
  <v-overlay v-model="rootStore.loading" persistent class="align-center justify-center loading">
    <v-progress-circular
      v-show="rootStore.loading"
      class="loading"
      size="100"
      width="10"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>

<script setup lang="ts">
import { useRootStore } from '@/stores/useRootStore';

const rootStore = useRootStore();
</script>

<style scoped>
:deep(.v-progress-circular__overlay){
  stroke:var(--hecto-primary);
}
</style>